import { createSlice } from "@reduxjs/toolkit";
import {
  register,
  login,
  logout,
  whoAmI,
  getNotifications,
  acceptTerms,
  verifyMfa,
} from "./actions";
import { RootState } from "../../utils/types";

const initialState: RootState["user"] & {
  mfaRequired?: boolean;
  tempToken?: string | null;
  token?: string | null;
} = {
  status: "idle",
  message: "",
  user: null,
  token: null,
  mfaRequired: false,
  tempToken: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
    },
    resetMfa: (state) => {
      state.mfaRequired = false;
      state.tempToken = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Register flow
      .addCase(register.pending, (state) => {
        state.status = "loading";
        state.message = "";
      })
      .addCase(register.fulfilled, (state, action: any) => {
        state.status = "success";
        state.message = action.payload?.message || "User created successfully!";
      })
      .addCase(register.rejected, (state, action: any) => {
        state.status = "failed";
        state.message =
          action.payload?.error?.message ||
          action.payload?.message ||
          "Registration failed";
      })

      // Login flow
      .addCase(login.pending, (state) => {
        state.status = "loading";
      })
     .addCase(login.fulfilled, (state, action: any) => {
  state.status = "success";

  if (action.payload?.mfaRequired) {
    state.mfaRequired = true;
    state.tempToken = action.payload.tempToken;
    state.user = null;
    state.token = null;
  } else {
    state.user = action.payload.user;
    state.token = action.payload.token; // ✅ important
    state.mfaRequired = false;
    state.tempToken = null;
  }
})
      .addCase(login.rejected, (state) => {
        state.user = null;
        state.status = "failed";
      })

      // MFA verify flow
      .addCase(verifyMfa.pending, (state) => {
        state.status = "loading";
      })
     .addCase(verifyMfa.fulfilled, (state, action: any) => {
  state.status = "success";
  state.user = action.payload.user;
  state.token = action.payload.token; // ✅ now captured
  state.mfaRequired = false;
  state.tempToken = null;
})
      .addCase(verifyMfa.rejected, (state) => {
        state.status = "failed";
      })

      // WhoAmI flow - for checking existing auth
      .addCase(whoAmI.pending, (state) => {
        state.status = "loading";
      })
     .addCase(whoAmI.fulfilled, (state, action: any) => {
  state.status = "success";
  state.user = action.payload.user ?? action.payload;
  state.token = action.payload.token ?? state.token; // safe fallback
  state.mfaRequired = false;
  state.tempToken = null;
})
      .addCase(whoAmI.rejected, (state) => {
        state.status = "failed";
        state.user = null;
        state.mfaRequired = false;
        state.tempToken = null;
      })
     .addCase(logout.fulfilled, (state) => {
  state.user = null;
  state.token = null;
  state.status = "idle";
  state.mfaRequired = false;
  state.tempToken = null;
}) ;
  },
});

export default authSlice.reducer;
export const { reset, resetMfa } = authSlice.actions;
